// @flow

import * as React from 'react';
import useRequest from 'hooks/useRequest';
import ApiAds from 'stores/api/ads';
import Loading from 'components/Loading';
import AdFeatured from '../../components/AdFeatured';
import catchApiError from 'utils/catchApiError';

import type { Ad } from 'stores/api/ads';

const AdFeaturedElement = (): React.Node => {
    const fetchFeaturedRequest = useRequest(() => ApiAds.featured());

    const [featured, setFeatured] = React.useState<Ad[]>([]);
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        const fetch = async () => {
            try {
                const data: any = await fetchFeaturedRequest.execute();
                setFeatured(data);
            } catch (_error) {
                const message = catchApiError(_error);
                setError(message);
            }
        };
        fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (fetchFeaturedRequest.isExecuting) {
        return <Loading />;
    }
    if (error) {
        return error;
    }
    if (featured.length === 0) {
        return null;
    }

    return <AdFeatured ads={featured} />;
};

export default AdFeaturedElement;
